"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var next_intl_1 = require("next-intl");
var navigation_1 = require("next/navigation");
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
// import { MyCoolingOffLimitQuery } from '@l2p/profile-api'
var CoolingOffPeriod = function (_a) {
    var coolOffPeriod = _a.coolOffPeriod;
    var _b = (0, react_1.useState)(false), mounted = _b[0], setMounted = _b[1];
    var t = (0, next_intl_1.useTranslations)('translation');
    var periods = (0, apps_shared_1.useCoolOffPeriodLimits)();
    var router = (0, navigation_1.useRouter)();
    // const initialValues = useMemo(
    //   () => ({
    //     period: periods.find(
    //       item => item.value === coolOffPeriod?.myCoolingOffLimit?.duration,
    //     ),
    //   }),
    //   [periods, coolOffPeriod],
    // )
    var initialValues = {};
    // const { setCoolingOffPeriod, isSubmitting: setCoolOffPeriodLoading } =
    //   useSetCoolingOffPeriod({
    //     successAction: router.refresh,
    //   })
    // const { deleteCoolingOffPeriod, isSubmitting: deleteCoolOffPeriodLoading } =
    //   useDeleteCoolingOffPeriod({
    //     successAction: router.refresh,
    //   })
    // const deleteCoolOffPeriodHandler = useCallback(() => {
    //   if (coolOffPeriod)
    //     deleteCoolingOffPeriod({
    //       id: coolOffPeriod?.coolingOffLimit?.get?.collingOffLimit?.id || '',
    //     })
    // }, [coolOffPeriod, deleteCoolingOffPeriod])
    (0, react_1.useEffect)(function () {
        setMounted(true);
        return function () { return setMounted(false); };
    }, []);
    var onSubmitHandler = (0, react_1.useCallback)(function (values) {
        // setCoolingOffPeriod({ duration: values?.period?.value })
    }, []);
    if (!mounted)
        return null;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, t('coolingOffPeriod')),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.description }, t('emptyCoolingOffPeriodNotification'))));
};
exports.default = CoolingOffPeriod;
